import {
  Stack,
  Typography
} from '@mui/material';
import React, { ReactNode } from 'react';



export type StyledDisplayFieldProps = {
  icon: ReactNode;
  label: string;
  children: ReactNode;
};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: StyledDisplayFieldProps) => {

  return (
    <Stack
      direction='row'
      columnGap='.5rem'
      alignItems='center'
    >
      {props.icon}
      <Typography
        variant='formLabel'
      >
        {props.label}
      </Typography>
      {props.children}

    </Stack>
  );
};
